import { Layout } from "react-admin";
import CustomMenu from "./CustomMenu";

export default function CustomLayout(props) {
  return <Layout {...props} menu={CustomMenu} />;
}
